export default __webpack_public_path__ + "static/media/illustration-study-3-n-m@3x.cd07e8a1.webp";